import { Box, Chip } from '@mui/material';
import { type_id_to_hiraganakatakana } from '../../lib/type';
import { type PokemonType } from '../../types/type';

interface PokemonTypeChipsProps {
  pokemonTypeIdList: number[];
}

type TypeChipStyle = {
  background: string;
  color: string;
  fallbackBackground?: string;
};

// 仕様書に合わせたタイプ別カラー
const TYPE_CHIP_STYLE_MAP: Record<PokemonType, TypeChipStyle> = {
  1: { background: '#A8A77A', color: '#1F1F1F' },
  2: { background: '#C22E28', color: '#FFFFFF' },
  3: { background: '#A98FF3', color: '#1F1F1F' },
  4: { background: '#A33EA1', color: '#FFFFFF' },
  5: { background: '#E2BF65', color: '#1F1F1F' },
  6: { background: '#B6A136', color: '#1F1F1F' },
  7: { background: '#A6B91A', color: '#1F1F1F' },
  8: { background: '#735797', color: '#FFFFFF' },
  9: { background: '#B7B7CE', color: '#1F1F1F' },
  10: { background: '#EE8130', color: '#FFFFFF' },
  11: { background: '#6390F0', color: '#FFFFFF' },
  12: { background: '#7AC74C', color: '#FFFFFF' },
  13: { background: '#F7D02C', color: '#1F1F1F' },
  14: { background: '#F95587', color: '#FFFFFF' },
  15: { background: '#96D9D6', color: '#1F1F1F' },
  16: { background: '#6F35FC', color: '#FFFFFF' },
  17: { background: '#705746', color: '#FFFFFF' },
  18: { background: '#D685AD', color: '#1F1F1F' },
  19: {
    background:
      'linear-gradient(90deg, #FFB3B3 0%, #FFD59E 20%, #FFF1A6 40%, #B9F6CA 60%, #B3E5FC 80%, #D1C4E9 100%)',
    color: '#1F1F1F',
    fallbackBackground: '#BDBDBD',
  },
};

function getPokemonTypeChipStyles(pokemonTypeId: number) {
  const style = TYPE_CHIP_STYLE_MAP[pokemonTypeId as PokemonType];
  if (!style) {
    return {};
  }
  return {
    background: style.background,
    color: style.color,
    ...(style.fallbackBackground ? { backgroundColor: style.fallbackBackground } : {}),
  };
}

function PokemonTypeChips({ pokemonTypeIdList }: PokemonTypeChipsProps) {
  // タイプ表示を共通化してスタイル調整を一箇所で行う
  const chipBaseSx = { height: 20, fontSize: '0.7rem', width: 80, minWidth: 80 };
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, alignItems: 'center' }}>
      <Chip
        label={type_id_to_hiraganakatakana(pokemonTypeIdList[0])}
        size="small"
        color="primary"
        variant="outlined"
        sx={{ ...chipBaseSx, ...getPokemonTypeChipStyles(pokemonTypeIdList[0]) }}
      />
      {/* 複合タイプの場合のみ2つ目を表示する */}
      {pokemonTypeIdList[1] && (
        <Chip
          label={type_id_to_hiraganakatakana(pokemonTypeIdList[1])}
          size="small"
          color="secondary"
          variant="outlined"
          sx={{ ...chipBaseSx, ...getPokemonTypeChipStyles(pokemonTypeIdList[1]) }}
        />
      )}
    </Box>
  );
}

export default PokemonTypeChips;
